import { render, staticRenderFns } from "./UserBasicForm.vue?vue&type=template&id=121da1ea&scoped=true&"
import script from "./UserBasicForm.vue?vue&type=script&lang=js&"
export * from "./UserBasicForm.vue?vue&type=script&lang=js&"
import style0 from "./UserBasicForm.vue?vue&type=style&index=0&id=121da1ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121da1ea",
  null
  
)

export default component.exports